import { createSelector } from 'reselect'

import { SpecificState } from '../../../types/reduxSaga-deprecated'

export const getVoucherActionsErrorSelector = (voucherId: string) =>
  createSelector(
    (state: SpecificState) => state.inbox.voucherActionError,
    (voucherActionError) => voucherActionError[voucherId],
  )
